import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useDateQueryParam = (paramName = "date") => {
    const [searchParams, setSearchParams] = useSearchParams();

    const today = new Date().toISOString().split("T")[0];
    const [date, setDate] = useState(today);

    // 1️⃣ Read from URL once on mount
    useEffect(() => {
        const dateFromUrl = searchParams.get(paramName);
        if (dateFromUrl) {
            setDate(dateFromUrl);
        }
        // intentionally run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 2️⃣ Sync state → URL
    useEffect(() => {
        const currentDateInUrl = searchParams.get(paramName);

        if (date && currentDateInUrl !== date) {
            setSearchParams({ [paramName]: date });
        }
    }, [date, paramName, searchParams, setSearchParams]);

    return [date, setDate];
};